import { render, staticRenderFns } from "./SentimentsSummary.vue?vue&type=template&id=ebd623ac&scoped=true"
import script from "./SentimentsSummary.vue?vue&type=script&lang=js"
export * from "./SentimentsSummary.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SentimentsSummary.vue?vue&type=style&index=1&id=ebd623ac&prod&scoped=true&lang=css"
import style2 from "./SentimentsSummary.vue?vue&type=style&index=2&id=ebd623ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd623ac",
  null
  
)

export default component.exports